import { render } from "./Address.vue?vue&type=template&id=54fa2b50"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
script.render = render

export default script